import { Orders_Companies } from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';

export type OrdersCompany = Pick<
  Orders_Companies,
  | 'name'
  | 'org_no'
  | 'address'
  | 'zip_code'
  | 'country'
  | 'county'
  | 'phone_no'
  | 'website'
  | 'kyc'
  | 'has_overdue'
  | 'is_active'
  | 'limit'
  | 'has_repayment_plan'
  | 'main_contact_id'
>;

export type GetCompanyType = {
  orders_companies_by_pk: OrdersCompany;
};

export const getCompanyQuery = gql`
  query getMerchantCompanyInformation($companyId: bigint!) {
    orders_companies_by_pk(id: $companyId) {
      id
      name
      org_no
      address
      zip_code
      country
      county
      phone_no
      website
      kyc
      has_overdue
      is_active
      limit
      has_repayment_plan
      main_contact_id
    }
  }
` as TypedDocumentNode<GetCompanyType, { companyId: number }>;
